import {
  PostTypeFacebookReel,
  PostTypePost,
} from '~publish/legacy/post/constants'

import type { ServiceMediaRestrictions } from './types'
import { CommonRatios } from '../aspect-ratio/CommonRatios'
import { aspectRatioMatch } from '../validation/rules/aspectRatioMatch'
import { aspectRatioRange } from '../validation/rules/aspectRatioRange'

export const FacebookMediaRestrictions: ServiceMediaRestrictions = {
  [PostTypePost]: {
    images: [
      aspectRatioRange.define({
        min: CommonRatios['4:5'],
        max: CommonRatios['1.91:1'],
      }),
    ],
  },
  [PostTypeFacebookReel]: {
    videos: [
      aspectRatioMatch.define(
        {
          expected: [CommonRatios['9:16'], CommonRatios['4:5']],
        },
        {
          messages: {
            generic: 'Your video must have a 9:16 or 4:5 aspect ratio',
          },
        },
      ),
    ],
  },
}
